// App.js
import 'rsuite/dist/rsuite.min.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import ProtectedRoute from './components/ProtectedRoute';
import ReduxInitializer from './components/ReduxInitializer';

import CoordinatorLoginPage from './coordinator/pages/auth/CoordinatorLoginPage.jsx';
import CoordinatorRegisterPage from './coordinator/pages/auth/CoordinatorRegisterPage.jsx';
import DashboardPage from './coordinator/pages/dashboard/DashboardPage.jsx';
import AddEventPage from './coordinator/pages/addevent/AddEventPage.jsx';
import EditAddEventPage from './coordinator/pages/editaddevent/EditAddEventPage.jsx';
import CoordinatorDashboardPage from './coordinator/pages/coordinatordashboard/CoordinatorDashboardPage.jsx';
import UserProfilePage from './coordinator/pages/userprofile/UserProfilePage.jsx';
import CoordinatorAuthorProfilePage from './coordinator/pages/coordinatorauthorprofilepage/CoordinatorAuthorProfilePage.jsx'

import ParentsViewPage from './parents/pages/parentsviewpage/ParentsViewPage.jsx';
import ParentsBook from './parents/pages/parentsbook/ParentsBook.jsx';
import ParentsBookReview from './parents/pages/parentsbookreview/ParentsBookReview.jsx';
import ParentsCheckout from './parents/pages/parentscheckout/ParentsCheckout.jsx';
import PurchaseSummaryPage from './parents/pages/purchasesummary/PurchaseSummaryPage.jsx';
import FullEventPage from './coordinator/pages/fulleventpage/FullEventPage.jsx';
import ParentsLoginPage from './parents/pages/auth/ParentsLoginPage.jsx';
import ParentsRegisterPage from './parents/pages/auth/ParentsRegisterPage.jsx';
import ParentsProfilePage from './parents/pages/parentsprofilepage/ParentsProfilePage.jsx'

import NewSchoolsOrganizationPage from './adminpanel/pages/newschoolsorganization/NewSchoolsOrganizationPage.jsx';
import NewSchoolsOrganizationDetailPage from './adminpanel/pages/newschoolsorganizationdetail/NewSchoolsOrganizationDetailPage.jsx';
import ActivatedSchoolsOrgPage from './adminpanel/pages/activatedschoolsorg/ActivatedSchoolsOrgPage.jsx';
import ConsolidatedOrdersPage from './adminpanel/pages/consolidatedorders/ConsolidatedOrdersPage.jsx';
import EventManagementPage from './adminpanel/pages/eventmanagement/EventManagementPage.jsx';
import AuthorTrackingPage from './adminpanel/pages/authortracking/AuthorTrackingPage.jsx';
import EventOrdersPage from './adminpanel/pages/eventorders/EventOrdersPage.jsx';
import ActivatedSchoolsOrgDetailsPage from './adminpanel/pages/activatedschoolsorgdetails/ActivatedSchoolsOrgDetailsPage.jsx';
import EventManagementDetailsPage from './adminpanel/pages/eventmanagementdetails/EventManagementDetailsPage.jsx';
import AuthorTrackingDetailsPage from './adminpanel/pages/authortrackingdetails/AuthorTrackingDetailsPage.jsx';
import OrderRefundPage from './adminpanel/pages/orderrefund/OrderRefundPage.jsx';
import InscriptionReportPage from './adminpanel/pages/inscriptionreport/InscriptionReportPage.jsx';
import ConsolidatedOrdersViewOrderPage from './adminpanel/pages/consolidatedordersvieworder/ConsolidatedOrdersViewOrderPage.jsx';
import OrderConfirmationPage from './adminpanel/pages/orderconfirmation/OrderConfirmationPage.jsx'
import RefundConfirmationPage from './adminpanel/pages/refundconfirmation/RefundConfirmationPage.jsx'
import AdminAuthorProfilePage from './adminpanel/pages/adminauthorprofilepage/AdminAuthorProfilePage.jsx'
//import InscriptionReportDetailPage from './adminpanel/pages/inscriptionreportdetail/InscriptionReportDetailPage.jsx'

import AuthorLoginPage from './authorpanel/pages/auth/AuthorLoginPage.jsx';
import AuthorRagistrationPage from './authorpanel/pages/auth/AuthorRagistrationPage.jsx';
import AuthorEditPage from './authorpanel/pages/authoreditpage/AuthorEditPage.jsx';
import AuthorProfilePage from './authorpanel/pages/authorprofilepage/AuthorProfilePage.jsx';
import MainIndexPage from './authorpanel/pages/mainindexpage/MainIndexPage.jsx';
import ResultSearchingPage from './authorpanel/pages/resultsearchingpage/ResultSearchingPage.jsx';
import WelcomeAuthormeetPage from './authorpanel/pages/welcomeauthormeetpage/WelcomeAuthormeetPage.jsx';

import PublishersLoginPage from './publishers/pages/auth/PublishersLoginPage.jsx';
import PublishersRegisterPage from './publishers/pages/auth/PublishersRegisterPage.jsx';
import PublisherProfilePage from './publishers/pages/publisherprofile/PublisherProfilePage.jsx';

import Login from './components/Login.jsx';
import ContractPage from './adminpanel/components/contract/ContractPage.jsx';
import ViewContractPage from './adminpanel/components/contract/ViewContractPage.jsx';
import TermAndCondition from './coordinator/pages/termandcondition/TermAndCondition.jsx'

import InscriptionReportDetailPage from './adminpanel/pages/inscriptionreportdetail/InscriptionReportDetailPage.jsx'

import 'swiper/css';
import './app.css';
import FindSchool from './components/common/FindSchool.jsx';

function App() {
  return (
    <CartProvider>
      <Router>
        <ReduxInitializer /> {/* This restores session if needed */}
        <Routes>
          <Route path="/" element={<MainIndexPage />} />
          <Route path="/general-login" element={<Login />} />
          <Route path="/find-your-school" element={<FindSchool />} />
          <Route path="/contract-page/:id" element={<ContractPage />} />
          <Route path="/view-contract/:id" element={<ViewContractPage />} />
          <Route path="/coordinator-register" element={<CoordinatorRegisterPage />} />
          <Route path="/coordinator-dashboard" element={
            <ProtectedRoute>
              <CoordinatorDashboardPage />
            </ProtectedRoute>
          } />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          } />
          <Route path="/add-event" element={
            <ProtectedRoute>
              <AddEventPage />
            </ProtectedRoute>
          } />
          <Route path="/edit-event" element={
            <ProtectedRoute>
              <EditAddEventPage />
            </ProtectedRoute>
          } />
          <Route path="/user-profile/:id" element={
            <ProtectedRoute>
              <UserProfilePage />
            </ProtectedRoute>
          } />
          <Route path="/AuthorEditPage/:id" element={
            <ProtectedRoute>
              <AuthorEditPage />
            </ProtectedRoute>
          } />

          <Route path="/general-login" element={<Login />} />
          <Route path="/TermAndCondition" element={<TermAndCondition />} />
          <Route path="/ParentsViewPage/:id" element={<ParentsViewPage />} />
          <Route path="/FullEventPage/:id" element={<FullEventPage />} />
          <Route path="/ParentsBook/:authorId" element={<ParentsBook />} />
          <Route path="/ParentsBookReview/:bookId" element={<ParentsBookReview />} />
          <Route path="/ParentsCheckout" element={<ParentsCheckout />} />
          <Route path="/PurchaseSummaryPage/:order_number" element={<PurchaseSummaryPage />} />
          <Route path="/NewSchoolsOrganizationPage" element={
            <ProtectedRoute>
              <NewSchoolsOrganizationPage />
            </ProtectedRoute>
          } />
          <Route path="/NewSchoolsOrganizationDetailPage/:id" element={
            <ProtectedRoute>
              <NewSchoolsOrganizationDetailPage />
            </ProtectedRoute>
          } />
          <Route path="/ActivatedSchoolsOrgPage" element={
            <ProtectedRoute>
              <ActivatedSchoolsOrgPage />
            </ProtectedRoute>
          } />
          <Route path="/ConsolidatedOrdersPage" element={
            <ProtectedRoute>
              <ConsolidatedOrdersPage />
            </ProtectedRoute>
          } />
          <Route path="/EventManagementPage" element={
            <ProtectedRoute>
              <EventManagementPage />
            </ProtectedRoute>
          } />
          <Route path="/AuthorTrackingPage" element={
            <ProtectedRoute>
              <AuthorTrackingPage />
            </ProtectedRoute>
          } />
          <Route path="/EventOrdersPage" element={
            <ProtectedRoute>
              <EventOrdersPage />
            </ProtectedRoute>
          } />
          <Route path="/ActivatedSchoolsOrgDetailsPage/:id" element={
            <ProtectedRoute>
              <ActivatedSchoolsOrgDetailsPage />
            </ProtectedRoute>
          } />
          <Route path="/EventManagementDetailsPage/:id" element={
            <ProtectedRoute>
              <EventManagementDetailsPage />
            </ProtectedRoute>
          } />
          <Route path="/AuthorTrackingDetailsPage/:id" element={
            <ProtectedRoute>
              <AuthorTrackingDetailsPage />
            </ProtectedRoute>
          } />
          <Route path="/OrderRefundPage/:order_number" element={
            <ProtectedRoute>
              <OrderRefundPage />
            </ProtectedRoute>
          } />
          <Route path="/InscriptionReportPage/:author_id" element={
            <ProtectedRoute>
              <InscriptionReportPage />
            </ProtectedRoute>
          } />
          <Route path="/ConsolidatedOrdersViewOrderPage" element={
            <ProtectedRoute>
              <ConsolidatedOrdersViewOrderPage />
            </ProtectedRoute>
          } />
          <Route path="/AdminAuthorProfilePage/:id" element={
            <ProtectedRoute>
              <AdminAuthorProfilePage />
            </ProtectedRoute>
          } />
          <Route path="/inscriptionReportDetailPage/:author_id/:event_id" element={
            <ProtectedRoute>
              <InscriptionReportDetailPage />
            </ProtectedRoute>
          } />

          <Route path="/AuthorLoginPage" element={<AuthorLoginPage />} />
          <Route path="/AuthorRagistrationPage" element={<AuthorRagistrationPage />} />
          <Route path="/ResultSearchingPage" element={<ResultSearchingPage />} />
          <Route path="/AuthorProfilePage/:id" element={<AuthorProfilePage />} />
          <Route path="/WelcomeAuthormeetPage" element={<WelcomeAuthormeetPage />} />
          <Route path="/ParentsLoginPage" element={<ParentsLoginPage />} />
          <Route path="/ParentsRegisterPage" element={<ParentsRegisterPage />} />
          <Route path="/ParentsProfilePage/:id" element={<ParentsProfilePage />} />
          <Route path="/PublishersLoginPage" element={<PublishersLoginPage />} />
          <Route path="/PublishersRegisterPage" element={<PublishersRegisterPage />} />
          <Route path="/PublisherProfilePage/:id" element={<PublisherProfilePage />} />
          <Route path="/CoordinatorAuthorProfilePage/:id" element={<CoordinatorAuthorProfilePage />} />
          <Route path="/OrderConfirmationPage/:order_number" element={<OrderConfirmationPage />} />
          <Route path="/RefundConfirmationPage" element={<RefundConfirmationPage />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;


